import LazyLoadImg from './LazyLoadImg';
export default LazyLoadImg;